
export default function Menu({ userType }) {
  return (
    <div className="menuContainer primary white">
      {userType === 1 ? <div className="large menuExchange">SUPER</div> : null}

      <div className="large menuExchange">MASTER</div>
      <div className="large menuExchange">BOOKED</div>
      <div className="large menuExchange">LIVE P&L</div>
      <div className="large menuExchange">NET P&L</div>
      <div className="large menuExchange">SELF LIVE P&L</div>
    </div>
  );
}
